import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageDedup({user,vulns,setPage}){
  var T=React.useContext(ThemeCtx).T;
  var _tab=useState("findings"); var tab=_tab[0]; var setTab=_tab[1];
  var _findings=useState([]); var findings=_findings[0]; var setFindings=_findings[1];
  var _stats=useState({}); var stats=_stats[0]; var setStats=_stats[1];
  var _rules=useState([]); var rules=_rules[0]; var setRules=_rules[1];
  var _corrRules=useState([]); var corrRules=_corrRules[0]; var setCorrRules=_corrRules[1];
  var _corrResults=useState(null); var corrResults=_corrResults[0]; var setCorrResults=_corrResults[1];
  var _chains=useState([]); var chains=_chains[0]; var setChains=_chains[1];
  var _scanning=useState(false); var scanning=_scanning[0]; var setScanning=_scanning[1];
  var _msg=useState({text:"",type:""}); var msg=_msg[0]; var setMsg=_msg[1];
  var _showAddRule=useState(false); var showAddRule=_showAddRule[0]; var setShowAddRule=_showAddRule[1];
  var _newRule=useState({name:"",description:"",rule_type:"exact_cve_asset",priority:10,action:"mark_duplicate",config:{}}); var newRule=_newRule[0]; var setNewRule=_newRule[1];
  var isAdmin=user.role==="admin";
  var showMsg=function(text,type){setMsg({text,type});setTimeout(function(){setMsg({text:"",type:""});},4000);};

  var loadFindings=function(){
    api.get("/dedup/findings").then(function(d){setFindings(d.findings||[]);setStats(d.stats||{});}).catch(function(){});
  };
  useEffect(function(){
    loadFindings();
    api.get("/dedup/rules").then(setRules).catch(function(){});
    api.get("/dedup/correlation/rules").then(setCorrRules).catch(function(){});
  },[]);

  var runScan=async function(){setScanning(true);try{await api.post("/dedup/run",{});showMsg("Scan started — refresh in a moment","success");setTimeout(loadFindings,4000);}catch(e){showMsg(e.message,"error");}setScanning(false);};
  var runCorr=async function(){setScanning(true);try{var d=await api.post("/dedup/correlation/run",{});setCorrResults(d);showMsg("Correlation complete","success");}catch(e){showMsg(e.message,"error");}setScanning(false);};
  var runChains=async function(){setScanning(true);try{var d=await api.post("/dedup/correlation/attack-chains",{});setChains(d.chains||[]);setTab("chains");showMsg("Attack chain analysis complete","success");}catch(e){showMsg(e.message,"error");}setScanning(false);};
  var reviewFinding=async function(id,action){try{await api.post("/dedup/findings/"+id+"/review",{action});loadFindings();showMsg(action+" done","success");}catch(e){showMsg(e.message,"error");}};
  var toggleRule=async function(id,enabled){try{await api.patch("/dedup/rules/"+id,{enabled});setRules(function(p){return p.map(function(r){return r.id===id?Object.assign({},r,{enabled}):r;});});}catch(e){showMsg(e.message,"error");}};
  var toggleCorrRule=async function(id,enabled){try{await api.patch("/dedup/correlation/rules/"+id,{enabled});setCorrRules(function(p){return p.map(function(r){return r.id===id?Object.assign({},r,{enabled}):r;});});}catch(e){showMsg(e.message,"error");}};
  var addRule=async function(){try{var r=await api.post("/dedup/rules",newRule);setRules(function(p){return p.concat([r]);});setShowAddRule(false);showMsg("Rule created","success");}catch(e){showMsg(e.message,"error");}};

  var iStyle={width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:7,color:T.text,fontSize:13,outline:"none",boxSizing:"border-box"};
  var lStyle={fontSize:11,color:T.text3,marginBottom:3,textTransform:"uppercase",letterSpacing:.5,display:"block"};
  var sc={pending:T.warning,confirmed:T.success,rejected:T.danger,auto_merged:"#8b5cf6"};

  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
    msg.text&&React.createElement("div",{style:{background:msg.type==="success"?T.success+"22":T.danger+"22",border:"1px solid "+(msg.type==="success"?T.success:T.danger)+"44",borderRadius:8,padding:"10px 14px",fontSize:13,color:msg.type==="success"?T.success:T.danger}},msg.text),
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(110px,1fr))",gap:10}},
      [["Total",findings.length,T.accent],["Pending",stats.pending||0,T.warning],["Confirmed",stats.confirmed||0,T.success],["Merged",stats.auto_merged||0,"#8b5cf6"],["Rejected",stats.rejected||0,T.danger]].map(function(item){
        return React.createElement(Card,{key:item[0],style:{textAlign:"center",padding:"10px 8px"}},React.createElement("div",{style:{fontSize:20,fontWeight:700,color:item[2]}},item[1]),React.createElement("div",{style:{fontSize:11,color:T.text3,marginTop:2}},item[0]));
      })
    ),
    React.createElement("div",{style:{display:"flex",gap:8,flexWrap:"wrap"}},
      React.createElement("button",{onClick:runScan,disabled:scanning,style:{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",cursor:"pointer",fontSize:13,fontWeight:600,opacity:scanning?0.6:1}},scanning?"\u23F3 Running...":"\uD83D\uDD0D Run Dedup Scan"),
      React.createElement("button",{onClick:runCorr,disabled:scanning,style:{background:"#8b5cf6",color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",cursor:"pointer",fontSize:13,fontWeight:600,opacity:scanning?0.6:1}},"\uD83E\uDDF5 Run Correlation"),
      React.createElement("button",{onClick:runChains,disabled:scanning,style:{background:"#ef4444",color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",cursor:"pointer",fontSize:13,fontWeight:600,opacity:scanning?0.6:1}},"\u26A1 Attack Chains"),
      React.createElement("button",{onClick:loadFindings,style:{background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:8,padding:"8px 14px",cursor:"pointer",fontSize:13}},"\u21BB Refresh")
    ),
    React.createElement("div",{style:{display:"flex",borderBottom:"1px solid "+T.border,overflowX:"auto"}},
      [["findings","Duplicates ("+findings.length+")"],["rules","Dedup Rules"],["correlation","Correlation Results"],["corr-rules","Correlation Rules"],["chains","\u26A1 Attack Chains"+(chains.length?" ("+chains.length+")":"")]].map(function(t){
        return React.createElement("button",{key:t[0],onClick:function(){setTab(t[0]);},style:{padding:"8px 14px",background:"transparent",border:"none",borderBottom:tab===t[0]?"2px solid "+T.accent:"2px solid transparent",color:tab===t[0]?T.accent:T.text3,cursor:"pointer",fontSize:12,fontWeight:tab===t[0]?600:400,whiteSpace:"nowrap"}},t[1]);
      })
    ),
    tab==="findings"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:8}},
      findings.length===0&&React.createElement(Card,null,React.createElement("div",{style:{color:T.text3,fontSize:13,textAlign:"center",padding:"20px"}},"No duplicates found. Run a scan to detect them.")),
      findings.map(function(f){
        return React.createElement(Card,{key:f.id,style:{padding:"12px 14px"}},
          React.createElement("div",{style:{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:10,flexWrap:"wrap"}},
            React.createElement("div",{style:{flex:1,minWidth:0}},
              React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8,marginBottom:8,flexWrap:"wrap"}},
                React.createElement(Bdg,{t:f.rule_name||"Rule",c:"#8b5cf6"}),
                React.createElement(Bdg,{t:Math.round(f.similarity_score)+"%",c:f.similarity_score>=90?T.danger:f.similarity_score>=70?"#f97316":T.warning}),
                React.createElement(Bdg,{t:f.status,c:sc[f.status]||T.text3})
              ),
              React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}},
                React.createElement("div",{style:{background:T.success+"11",border:"1px solid "+T.success+"33",borderRadius:7,padding:"8px 10px"}},
                  React.createElement("div",{style:{fontSize:10,color:T.success,fontWeight:600,marginBottom:3}},"PRIMARY"),
                  React.createElement("div",{style:{fontSize:12,fontWeight:600,color:T.accent}},f.primary_vuln_id),
                  React.createElement("div",{style:{fontSize:12,color:T.text}},(f.primary_title||"").slice(0,35)),
                  React.createElement("div",{style:{fontSize:11,color:T.text3}},f.primary_asset," \u00b7 ",f.primary_severity)
                ),
                React.createElement("div",{style:{background:T.warning+"11",border:"1px solid "+T.warning+"33",borderRadius:7,padding:"8px 10px"}},
                  React.createElement("div",{style:{fontSize:10,color:T.warning,fontWeight:600,marginBottom:3}},"DUPLICATE"),
                  React.createElement("div",{style:{fontSize:12,fontWeight:600,color:T.accent}},f.duplicate_vuln_id),
                  React.createElement("div",{style:{fontSize:12,color:T.text}},(f.dup_title||"").slice(0,35)),
                  React.createElement("div",{style:{fontSize:11,color:T.text3}},f.dup_asset," \u00b7 ",f.dup_severity)
                )
              )
            ),
            f.status==="pending"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:6,flexShrink:0}},
              React.createElement("button",{onClick:function(){reviewFinding(f.id,"confirm");},style:{background:T.success+"22",color:T.success,border:"1px solid "+T.success+"44",borderRadius:6,padding:"5px 12px",cursor:"pointer",fontSize:11,fontWeight:600}},"\u2713 Confirm"),
              React.createElement("button",{onClick:function(){reviewFinding(f.id,"merge");},style:{background:"#8b5cf622",color:"#8b5cf6",border:"1px solid #8b5cf644",borderRadius:6,padding:"5px 12px",cursor:"pointer",fontSize:11,fontWeight:600}},"\u21AA Merge"),
              React.createElement("button",{onClick:function(){reviewFinding(f.id,"reject");},style:{background:T.danger+"22",color:T.danger,border:"1px solid "+T.danger+"44",borderRadius:6,padding:"5px 12px",cursor:"pointer",fontSize:11}},"\u2715 Reject")
            )
          )
        );
      })
    ),
    tab==="rules"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:8}},
      isAdmin&&React.createElement("button",{onClick:function(){setShowAddRule(true);},style:{alignSelf:"flex-start",background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",cursor:"pointer",fontSize:13,fontWeight:600}},"+ Custom Rule"),
showAddRule&&React.createElement(Modal,{title:"Add Dedup Rule",onClose:function(){setShowAddRule(false);},width:580},
        React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:14}},

          // Name + Priority
          React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}},
            React.createElement("div",null,
              React.createElement("label",{style:lStyle},"Rule Name *"),
              React.createElement("input",{type:"text",value:newRule.name,
                onChange:function(e){setNewRule(function(p){return Object.assign({},p,{name:e.target.value});});},
                placeholder:"e.g. Critical CVE + Asset Match",style:iStyle})
            ),
            React.createElement("div",null,
              React.createElement("label",{style:lStyle},"Priority (1=highest)"),
              React.createElement("input",{type:"number",value:newRule.priority,min:1,max:100,
                onChange:function(e){setNewRule(function(p){return Object.assign({},p,{priority:parseInt(e.target.value)||10});});},
                style:iStyle})
            )
          ),

          // Description
          React.createElement("div",null,
            React.createElement("label",{style:lStyle},"Description"),
            React.createElement("input",{type:"text",value:newRule.description,
              onChange:function(e){setNewRule(function(p){return Object.assign({},p,{description:e.target.value});});},
              placeholder:"What does this rule detect?",style:iStyle})
          ),

          // Rule Type
          React.createElement("div",null,
            React.createElement("label",{style:lStyle},"Rule Type"),
            React.createElement("select",{value:newRule.rule_type,
              onChange:function(e){setNewRule(function(p){return Object.assign({},p,{rule_type:e.target.value,config:{confidence:85,match_fields:["cve"]}});});},
              style:iStyle},
              React.createElement("option",{value:"exact_cve_asset"},   "Exact CVE + Asset — identical CVE on same asset"),
              React.createElement("option",{value:"cve_across_assets"}, "CVE Across Assets — same CVE on different assets"),
              React.createElement("option",{value:"fuzzy_asset"},       "Fuzzy Asset Match — same CVE, similar asset name"),
              React.createElement("option",{value:"cwe_match"},         "CWE + Scanner Match — same weakness from same scanner"),
              React.createElement("option",{value:"scanner_id"},        "Scanner Finding ID — identical external scan ID"),
              React.createElement("option",{value:"title_similarity"},  "Title Similarity — similar vulnerability titles"),
              user.role==="admin"&&React.createElement("option",{value:"custom_sql"},"Custom Query Builder (Admin only)")
            )
          ),

          // ── Match Fields — checkboxes ───────────────────────────────────────
          (["exact_cve_asset","cve_across_assets","cwe_match","title_similarity"].includes(newRule.rule_type))&&
          React.createElement("div",{style:{background:T.inset,border:"1px solid "+T.border,padding:"12px 14px"}},
            React.createElement("div",{style:{fontSize:10,color:"#A100FF",fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:10}},
              "Match Combination — select fields that must match"
            ),
            React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}},
              [
                {k:"cve",         l:"CVE ID",           desc:"Same CVE number"},
                {k:"cwe",         l:"CWE Category",     desc:"Same weakness type"},
                {k:"asset",       l:"Asset Name",       desc:"Same asset/host"},
                {k:"severity",    l:"Severity Level",   desc:"Same severity"},
                {k:"scan_type",   l:"Scan Type",        desc:"Same scan method"},
                {k:"scanner",     l:"Scanner Tool",     desc:"Same scanner"},
                {k:"pod",         l:"Team Pod",         desc:"Same delivery pod"},
                {k:"owner",       l:"Asset Owner",      desc:"Same owner"},
              ].map(function(field){
                var sel=(newRule.config.match_fields||["cve"]).includes(field.k);
                return React.createElement("label",{key:field.k,
                  style:{display:"flex",alignItems:"flex-start",gap:8,padding:"6px 8px",
                    background:sel?"#A100FF0d":"transparent",
                    border:"1px solid "+(sel?"#A100FF44":T.border),
                    cursor:"pointer",userSelect:"none"}},
                  React.createElement("input",{type:"checkbox",checked:sel,
                    onChange:function(){
                      setNewRule(function(p){
                        var cur=p.config.match_fields||["cve"];
                        var next=sel?cur.filter(function(x){return x!==field.k;}):cur.concat([field.k]);
                        if(next.length===0) next=["cve"];
                        return Object.assign({},p,{config:Object.assign({},p.config,{match_fields:next})});
                      });
                    },
                    style:{marginTop:2,accentColor:"#A100FF",width:14,height:14,flexShrink:0}
                  }),
                  React.createElement("div",null,
                    React.createElement("div",{style:{fontSize:12,fontWeight:sel?600:400,color:sel?"#A100FF":T.text}}),field.l,
                    React.createElement("div",{style:{fontSize:10,color:T.text3,marginTop:1}}),field.desc
                  )
                );
              })
            ),
            React.createElement("div",{style:{marginTop:8,fontSize:11,color:T.text3}},
              "Active combination: ",
              React.createElement("strong",{style:{color:"#A100FF"}},
                (newRule.config.match_fields||["cve"]).join(" + ").toUpperCase()
              )
            )
          ),

          // Threshold slider (fuzzy + title)
          ["fuzzy_asset","title_similarity"].includes(newRule.rule_type)&&
          React.createElement("div",null,
            React.createElement("label",{style:lStyle},"Similarity Threshold"),
            React.createElement("div",{style:{display:"flex",alignItems:"center",gap:12}},
              React.createElement("input",{type:"range",min:50,max:100,
                value:newRule.config.threshold||80,
                onChange:function(e){setNewRule(function(p){return Object.assign({},p,{config:Object.assign({},p.config,{threshold:parseInt(e.target.value)})});});},
                style:{flex:1,accentColor:"#A100FF"}
              }),
              React.createElement("span",{style:{fontSize:14,fontWeight:700,color:"#A100FF",minWidth:40}}),
              (newRule.config.threshold||80)+"%"
            ),
            React.createElement("div",{style:{fontSize:11,color:T.text3,marginTop:2}},
              "Match assets/titles that are at least "+(newRule.config.threshold||80)+"% similar"
            )
          ),

          // Severity filter — checkboxes
          React.createElement("div",null,
            React.createElement("label",{style:lStyle},"Apply to Severities (leave all unchecked = apply to all)"),
            React.createElement("div",{style:{display:"flex",gap:8}},
              [["Critical","#ef4444"],["High","#f97316"],["Medium","#f59e0b"],["Low","#22c55e"]].map(function(sv){
                var sel=(newRule.config.severities||[]).includes(sv[0]);
                return React.createElement("label",{key:sv[0],
                  style:{display:"flex",alignItems:"center",gap:6,padding:"6px 12px",
                    background:sel?sv[1]+"22":"transparent",
                    border:"1px solid "+(sel?sv[1]:T.border),
                    cursor:"pointer",userSelect:"none",flex:1,justifyContent:"center"}},
                  React.createElement("input",{type:"checkbox",checked:sel,
                    onChange:function(){
                      setNewRule(function(p){
                        var cur=p.config.severities||[];
                        var next=sel?cur.filter(function(x){return x!==sv[0];}):cur.concat([sv[0]]);
                        return Object.assign({},p,{config:Object.assign({},p.config,{severities:next})});
                      });
                    },
                    style:{accentColor:sv[1],width:13,height:13}
                  }),
                  React.createElement("span",{style:{fontSize:12,fontWeight:sel?700:400,color:sel?sv[1]:T.text3}}),sv[0]
                );
              })
            ),
            React.createElement("div",{style:{fontSize:11,color:T.text3,marginTop:4}},
              (newRule.config.severities||[]).length===0
                ? "Applies to all severities"
                : "Applies to: "+(newRule.config.severities||[]).join(", ")
            )
          ),

          // Scan type filter — checkboxes
          React.createElement("div",null,
            React.createElement("label",{style:lStyle},"Apply to Scan Types (leave all unchecked = apply to all)"),
            React.createElement("div",{style:{display:"flex",flexWrap:"wrap",gap:5}},
              ["manual","sast","dast","infra","sca","container","api","cloud","pt"].map(function(st){
                var sel=(newRule.config.scan_types||[]).includes(st);
                return React.createElement("label",{key:st,
                  style:{display:"flex",alignItems:"center",gap:5,padding:"4px 9px",
                    background:sel?"#A100FF18":"transparent",
                    border:"1px solid "+(sel?"#A100FF66":T.border),
                    cursor:"pointer",userSelect:"none"}},
                  React.createElement("input",{type:"checkbox",checked:sel,
                    onChange:function(){
                      setNewRule(function(p){
                        var cur=p.config.scan_types||[];
                        var next=sel?cur.filter(function(x){return x!==st;}):cur.concat([st]);
                        return Object.assign({},p,{config:Object.assign({},p.config,{scan_types:next})});
                      });
                    },
                    style:{accentColor:"#A100FF",width:12,height:12}
                  }),
                  React.createElement("span",{style:{fontSize:10,fontWeight:sel?700:400,color:sel?"#A100FF":T.text3,
                    textTransform:"uppercase",letterSpacing:.5}}),st
                );
              })
            )
          ),

          // Confidence score
          React.createElement("div",null,
            React.createElement("label",{style:lStyle},"Minimum Confidence Score"),
            React.createElement("div",{style:{display:"flex",alignItems:"center",gap:12}},
              React.createElement("input",{type:"range",min:50,max:100,
                value:newRule.config.confidence||85,
                onChange:function(e){setNewRule(function(p){return Object.assign({},p,{config:Object.assign({},p.config,{confidence:parseInt(e.target.value)})});});},
                style:{flex:1,accentColor:"#A100FF"}
              }),
              React.createElement("span",{style:{fontSize:14,fontWeight:700,color:"#A100FF",minWidth:40}}),
              (newRule.config.confidence||85)+"%"
            )
          ),

          // Action — radio-style checkboxes
          React.createElement("div",null,
            React.createElement("label",{style:lStyle},"Action on Match"),
            React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}},
              [
                {v:"mark_duplicate",l:"Mark as Duplicate",    d:"Flag for manual review",  c:"#f97316"},
                {v:"merge",         l:"Auto Merge",            d:"Keep primary, close dup", c:"#ef4444"},
                {v:"suppress",      l:"Suppress",              d:"Hide from main list",     c:"#8b5cf6"},
                {v:"flag",          l:"Flag for Review",       d:"Add review flag only",    c:"#3b82f6"},
              ].map(function(a){
                var sel=newRule.action===a.v;
                return React.createElement("label",{key:a.v,
                  style:{display:"flex",alignItems:"flex-start",gap:8,padding:"8px 10px",
                    background:sel?a.c+"15":"transparent",
                    border:"1px solid "+(sel?a.c:T.border),
                    cursor:"pointer",userSelect:"none"}},
                  React.createElement("input",{type:"radio",name:"rule_action",checked:sel,
                    onChange:function(){setNewRule(function(p){return Object.assign({},p,{action:a.v});});},
                    style:{marginTop:2,accentColor:a.c,flexShrink:0}
                  }),
                  React.createElement("div",null,
                    React.createElement("div",{style:{fontSize:12,fontWeight:sel?700:400,color:sel?a.c:T.text}}),a.l,
                    React.createElement("div",{style:{fontSize:10,color:T.text3,marginTop:1}}),a.d
                  )
                );
              })
            )
          ),

          // Custom Query Builder (admin only — no free SQL)
          newRule.rule_type==="custom_sql"&&React.createElement("div",{style:{background:"#ef444411",border:"1px solid #ef444433",padding:"12px 14px"}},
            React.createElement("div",{style:{fontSize:11,fontWeight:700,color:"#ef4444",marginBottom:8}},
              " Custom Query Builder — Admin Only"
            ),
            React.createElement("div",{style:{fontSize:11,color:T.text2,marginBottom:10,lineHeight:1.6}},
              "Build your query using the visual builder below. Only SELECT statements on the vulnerabilities table are permitted. Dangerous keywords (DROP, DELETE, INSERT, etc.) are blocked server-side."
            ),
            React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}},
              React.createElement("div",null,
                React.createElement("label",{style:lStyle},"Filter by Severity"),
                React.createElement("select",{multiple:true,
                  value:newRule.config.qb_severities||[],
                  onChange:function(e){
                    var vals=Array.from(e.target.selectedOptions).map(function(o){return o.value;});
                    setNewRule(function(p){return Object.assign({},p,{config:Object.assign({},p.config,{qb_severities:vals})});});
                  },
                  style:Object.assign({},iStyle,{height:90})},
                  ["Critical","High","Medium","Low"].map(function(s){return React.createElement("option",{key:s,value:s},s);})
                )
              ),
              React.createElement("div",null,
                React.createElement("label",{style:lStyle},"Group by Field"),
                React.createElement("select",{value:newRule.config.qb_group_by||"cve",
                  onChange:function(e){setNewRule(function(p){return Object.assign({},p,{config:Object.assign({},p.config,{qb_group_by:e.target.value})});});},
                  style:iStyle},
                  [["cve","CVE ID"],["asset","Asset Name"],["cwe_id","CWE Category"],["scanner_name","Scanner"],["pod_id","Pod"],["owner_id","Owner"]].map(function(o){
                    return React.createElement("option",{key:o[0],value:o[0]},o[1]);
                  })
                )
              )
            ),
            React.createElement("div",{style:{fontSize:11,color:T.text3,marginBottom:4}},
              "Generated query preview:"
            ),
            React.createElement("div",{style:{background:"#000",color:"#22c55e",padding:"8px 10px",fontSize:10,fontFamily:"monospace",lineHeight:1.6,overflowX:"auto"}},
              "SELECT v1.id AS primary_id, v2.id AS dup_id",React.createElement("br",null),
              "FROM vulnerabilities v1",React.createElement("br",null),
              "JOIN vulnerabilities v2 ON v1."+(newRule.config.qb_group_by||"cve")+"=v2."+(newRule.config.qb_group_by||"cve"),React.createElement("br",null),
              "  AND v1.id != v2.id",React.createElement("br",null),
              (newRule.config.qb_severities||[]).length>0
                ? "WHERE v1.severity IN ('"+((newRule.config.qb_severities||[]).join("','"))+"')"
                : "-- (no severity filter)"
            )
          ),

          // Actions row
          React.createElement("div",{style:{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:4,borderTop:"1px solid "+T.border}},
            React.createElement("button",{onClick:function(){setShowAddRule(false);},
              style:{background:"transparent",border:"1px solid "+T.border,color:T.text3,padding:"9px 16px",cursor:"pointer",fontSize:12}},
              "Cancel"
            ),
            React.createElement("button",{onClick:addRule,disabled:!newRule.name.trim(),
              style:{background:newRule.name.trim()?"#A100FF":"#ccc",color:"#fff",border:"none",
                padding:"9px 20px",cursor:newRule.name.trim()?"pointer":"not-allowed",
                fontSize:12,fontWeight:700,letterSpacing:.5}},
              "CREATE RULE >"
            )
          )
        )
      ),
      rules.map(function(r){
        return React.createElement(Card,{key:r.id,style:{padding:"12px 14px"}},
          React.createElement("div",{style:{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}},
            React.createElement("div",{style:{flex:1}},
              React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8,marginBottom:3,flexWrap:"wrap"}},
                React.createElement("span",{style:{fontSize:13,fontWeight:600,color:T.text}},r.name),
                React.createElement(Bdg,{t:r.rule_type,c:"#8b5cf6"}),
                React.createElement(Bdg,{t:r.action,c:r.action==="merge"?T.danger:"#3b82f6"})
              ),
              r.description&&React.createElement("div",{style:{fontSize:12,color:T.text3}},r.description)
            ),
            isAdmin&&React.createElement("div",{style:{display:"flex",alignItems:"center",gap:6}},
              React.createElement("input",{type:"checkbox",checked:!!r.enabled,onChange:function(e){toggleRule(r.id,e.target.checked);},style:{width:16,height:16}}),
              React.createElement("span",{style:{fontSize:12,color:T.text2}},r.enabled?"On":"Off")
            )
          )
        );
      })
    ),
    tab==="correlation"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
      !corrResults&&React.createElement(Card,null,React.createElement("div",{style:{color:T.text3,fontSize:13,textAlign:"center",padding:"20px"}},"Click Run Correlation to group findings.")),
      corrResults&&(corrResults.groups||[]).map(function(group){
        return React.createElement(Card,{key:group.rule},
          React.createElement("div",{style:{fontSize:13,fontWeight:600,color:T.text,marginBottom:8}},group.rule," \u2014 ",group.type),
          group.groups.slice(0,20).map(function(g){
            return React.createElement("div",{key:g.key,style:{display:"flex",alignItems:"center",gap:10,padding:"7px 10px",background:T.inset,borderRadius:7,marginBottom:4}},
              React.createElement("div",{style:{flex:1,fontSize:13,color:T.text,fontWeight:500}},g.key||"Unknown"),
              React.createElement(Bdg,{t:g.max_sev||"Low",c:SEV_C[g.max_sev]||T.text3}),
              React.createElement("div",{style:{fontSize:12,color:T.text3}},g.cnt," vulns")
            );
          })
        );
      })
    ),
    tab==="corr-rules"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:8}},
      corrRules.map(function(r){
        return React.createElement(Card,{key:r.id,style:{padding:"12px 14px"}},
          React.createElement("div",{style:{display:"flex",alignItems:"center",gap:10}},
            React.createElement("div",{style:{flex:1}},
              React.createElement("div",{style:{fontSize:13,fontWeight:600,color:T.text}},r.name),
              r.description&&React.createElement("div",{style:{fontSize:12,color:T.text3,marginTop:2}},r.description)
            ),
            React.createElement(Bdg,{t:r.group_by,c:"#3b82f6"}),
            isAdmin&&React.createElement("div",{style:{display:"flex",alignItems:"center",gap:6}},
              React.createElement("input",{type:"checkbox",checked:!!r.enabled,onChange:function(e){toggleCorrRule(r.id,e.target.checked);},style:{width:16,height:16}}),
              React.createElement("span",{style:{fontSize:12,color:T.text2}},r.enabled?"On":"Off")
            )
          )
        );
      })
    ),
    tab==="chains"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
      chains.length===0
        ? React.createElement(Card,null,
            React.createElement("div",{style:{color:T.text3,fontSize:13,textAlign:"center",padding:"24px"}},
              React.createElement("div",{style:{fontSize:28,marginBottom:8}},"\u26A1"),
              React.createElement("div",{style:{fontWeight:600,marginBottom:4}},"No attack chains detected yet"),
              React.createElement("div",{style:{marginBottom:12}},"Click \u26A1 Attack Chains above to run analysis."),
              React.createElement("div",{style:{fontSize:11,color:T.text3}},"Detects: SAST+DAST confirmed \xb7 SCA+DAST reachable \xb7 Infra+Container \xb7 High-risk assets")
            )
          )
        : React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
            React.createElement(Card,{style:{padding:"14px 16px"}},
              React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}},
                React.createElement("div",null,
                  React.createElement("div",{style:{fontSize:14,fontWeight:700,color:T.text,marginBottom:4}},"\u26A1 "+chains.length+" attack chain"+(chains.length!==1?"s":"")+" detected"),
                  React.createElement("div",{style:{fontSize:12,color:T.text3}},chains.reduce(function(s,c){return s+c.count;},0)+" total risk pairs")
                ),
                React.createElement("div",{style:{fontSize:11,color:T.text3,fontStyle:"italic"}},"Graph shown below")
              )
            ),
            chains.map(function(chain){
              var CC={SAST_DAST_CONFIRMED:"#ef4444",SCA_DAST_REACHABLE:"#f97316",INFRA_CONTAINER_CHAIN:"#3B8BD4",INJECTION_NETWORK_EXPOSED:"#ec4899",HIGH_RISK_ASSET:"#8b5cf6",ERROR:"#64748b"};
              var CI={SAST_DAST_CONFIRMED:"\uD83D\uDD25",SCA_DAST_REACHABLE:"\uD83D\uDCE6",INFRA_CONTAINER_CHAIN:"\uD83D\uDC33",INJECTION_NETWORK_EXPOSED:"\uD83D\uDC89",HIGH_RISK_ASSET:"\uD83C\uDFAF",ERROR:"\u26A0"};
              var c=CC[chain.type]||T.accent; var ico=CI[chain.type]||"\uD83D\uDD17";
              return React.createElement(Card,{key:chain.type,style:{borderLeft:"4px solid "+c,padding:"12px 16px"}},
                React.createElement("div",{style:{display:"flex",alignItems:"center",gap:12}},
                  React.createElement("div",{style:{fontSize:20}},ico),
                  React.createElement("div",{style:{flex:1}},
                    React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}},
                      React.createElement("span",{style:{fontSize:13,fontWeight:700,color:c}},chain.label),
                      React.createElement(Bdg,{t:chain.severity_boost||"HIGH",c:chain.severity_boost==="CRITICAL"?"#ef4444":"#f97316"}),
                      React.createElement(Bdg,{t:chain.count+" pairs",c:T.text3})
                    ),
                    React.createElement("div",{style:{fontSize:11,color:T.text3,marginTop:3}},chain.description)
                  )
                )
              );
            }),
            React.createElement(PageAttackPath,{user:user,setPage:setPage})
          )
    )
  );
}


function CVSSGauge({value,max,color,label}){
  var pct=max>0?Math.min(100,Math.round((value/max)*100)):0;
  var c=color||"#A100FF";
  var r=28; var circ=2*Math.PI*r;
  return React.createElement("div",{style:{display:"flex",flexDirection:"column",alignItems:"center",gap:4}},
    React.createElement("svg",{width:70,height:70,viewBox:"0 0 70 70"},
      React.createElement("circle",{cx:35,cy:35,r:r,fill:"none",stroke:"#e5e7eb",strokeWidth:7}),
      React.createElement("circle",{cx:35,cy:35,r:r,fill:"none",stroke:c,strokeWidth:7,
        strokeDasharray:(pct/100)*circ+" "+circ,
        strokeDashoffset:circ*0.25,strokeLinecap:"round",
        style:{transition:"stroke-dasharray .5s"}}),
      React.createElement("text",{x:35,y:38,textAnchor:"middle",fontSize:14,fontWeight:800,fill:c},
        value>0?value.toFixed(1):"N/A")
    ),
    React.createElement("div",{style:{fontSize:10,color:"#64748b",fontWeight:600,
      textTransform:"uppercase",letterSpacing:.8}},label)
  );
}


function VulnDetailSection({title,content,vuln,field,user,onSave,isCode}){
  var T=React.useContext(ThemeCtx).T;
  var _editing=useState(false); var editing=_editing[0]; var setEditing=_editing[1];
  var _val=useState(content||""); var val=_val[0]; var setVal=_val[1];
  var _saving=useState(false); var saving=_saving[0]; var setSaving=_saving[1];
  var canEdit=["admin","lead","team"].includes(user.role);

  var save=async function(){
    setSaving(true);
    try{
      await api.patch("/vulns/"+vuln.id,{[field]:val});
      onSave&&onSave(field,val);
      setEditing(false);
    }catch(e){}
    setSaving(false);
  };

  return React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,padding:"14px 16px"}},
    React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}},
      React.createElement("div",{style:{fontSize:11,fontWeight:700,color:T.text,textTransform:"uppercase",letterSpacing:.5}},title),
      canEdit&&!editing&&React.createElement("button",{onClick:function(){setEditing(true);setVal(content||"");},
        style:{background:"transparent",border:"1px solid #A100FF44",color:"#A100FF",padding:"3px 10px",cursor:"pointer",fontSize:10,fontWeight:600}},"Edit")
    ),
    editing
      ? React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:8}},
          React.createElement("textarea",{value:val,rows:6,
            onChange:function(e){setVal(e.target.value);},
            style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,color:T.text,
              fontSize:isCode?11:12,outline:"none",resize:"vertical",
              fontFamily:isCode?"monospace":"inherit",boxSizing:"border-box"}}),
          React.createElement("div",{style:{display:"flex",gap:6,justifyContent:"flex-end"}},
            React.createElement("button",{onClick:function(){setEditing(false);},
              style:{background:"transparent",border:"1px solid "+T.border,color:T.text3,padding:"6px 14px",cursor:"pointer",fontSize:11}},"Cancel"),
            React.createElement("button",{onClick:save,disabled:saving,
              style:{background:"#A100FF",color:"#fff",border:"none",padding:"6px 16px",cursor:"pointer",fontSize:11,fontWeight:700,opacity:saving?0.6:1}},
              saving?"Saving...":"Save")
          )
        )
      : React.createElement("div",{style:{
          fontSize:isCode?11:12,color:content?T.text:T.text3,lineHeight:1.8,
          fontFamily:isCode?"monospace":"inherit",
          whiteSpace:isCode?"pre-wrap":"normal",
          background:isCode?T.inset:"transparent",
          padding:isCode?"10px 12px":"0"
        }},content||"Not specified — click Edit to add")
  );
}


function TicketWidget({vuln,user}){
  var T=React.useContext(ThemeCtx).T;
  var _ticket=useState(null); var ticket=_ticket[0]; var setTicket=_ticket[1];
  var _loading=useState(false); var loading=_loading[0]; var setLoading=_loading[1];
  var _msg=useState(""); var msg=_msg[0]; var setMsg=_msg[1];
  var PURPLE="#A100FF";

  useEffect(function(){
    api.get("/tickets/"+vuln.id).then(function(d){if(d.ticket_ref)setTicket(d);}).catch(function(){});
  },[vuln.id]);

  var createTicket=async function(system){
    setLoading(true); setMsg("");
    try{
      var d=await api.post("/tickets/create",{vuln_id:vuln.id,system:system});
      setTicket({ticket_ref:d.ticket_ref,ticket_url:d.ticket_url,ticket_system:system});
      setMsg(d.message);
    }catch(e){setMsg("Error: "+e.message);}
    setLoading(false);
    setTimeout(function(){setMsg("");},5000);
  };

  if(ticket&&ticket.ticket_ref){
    var sysColor=ticket.ticket_system==="jira"?"#0052CC":"#00897B";
    var sysLabel=ticket.ticket_system==="jira"?"Jira":"ServiceNow";
    return React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}},
      React.createElement("div",{style:{background:sysColor+"11",border:"1px solid "+sysColor+"44",padding:"6px 12px",display:"flex",alignItems:"center",gap:8}},
        React.createElement("div",{style:{fontSize:10,color:sysColor,fontWeight:700,letterSpacing:.5,textTransform:"uppercase"}},sysLabel+" Ticket"),
        React.createElement("a",{href:ticket.ticket_url,target:"_blank",rel:"noopener noreferrer",
          style:{fontSize:13,fontWeight:700,color:sysColor,textDecoration:"none"}},ticket.ticket_ref)
      ),
      React.createElement("div",{style:{fontSize:11,color:T.text3}},"Linked")
    );
  }

  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:6}},
    msg&&React.createElement("div",{style:{fontSize:11,color:msg.startsWith("Error")?"#ef4444":"#22c55e",padding:"4px 8px",background:msg.startsWith("Error")?"#ef444411":"#22c55e11"}} ,msg),
    React.createElement("div",{style:{display:"flex",gap:6,flexWrap:"wrap"}},
      React.createElement("button",{onClick:function(){createTicket("jira");},disabled:loading,
        style:{background:"#0052CC",color:"#fff",border:"none",padding:"6px 14px",cursor:"pointer",fontSize:11,fontWeight:600,opacity:loading?0.6:1}},
        loading?"Creating...":"Create Jira Ticket"
      ),
      React.createElement("button",{onClick:function(){createTicket("servicenow");},disabled:loading,
        style:{background:"#00897B",color:"#fff",border:"none",padding:"6px 14px",cursor:"pointer",fontSize:11,fontWeight:600,opacity:loading?0.6:1}},
        loading?"Creating...":"Create ServiceNow Ticket"
      )
    ),
    React.createElement("div",{style:{fontSize:10,color:T.text3}},"Note: Configure Jira/ServiceNow in Integrations for live tickets. Demo mode creates placeholder references.")
  );
}


function ExceptionTabInline({vuln,user}){
  var T=React.useContext(ThemeCtx).T;
  var _exc=useState([]); var exc=_exc[0]; var setExc=_exc[1];
  var _showForm=useState(false); var showForm=_showForm[0]; var setShowForm=_showForm[1];
  var _form=useState({justification:"",compensating_controls:""}); var form=_form[0]; var setForm=_form[1];
  var _review=useState({status:"Approved",review_note:""}); var review=_review[0]; var setReview=_review[1];
  var _reviewing=useState(null); var reviewing=_reviewing[0]; var setReviewing=_reviewing[1];
  var _msg=useState(""); var msg=_msg[0]; var setMsg=_msg[1];
  var iStyle={width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:12,outline:"none",boxSizing:"border-box"};
  var sc={"Pending":T.warning,"Approved":"#22c55e","Rejected":"#ef4444"};
  var canReview=["lead","admin"].includes(user.role);

  useEffect(function(){
    api.get("/exceptions?vuln_id="+vuln.id).then(setExc).catch(function(){});
  },[vuln.id]);

  var submit=async function(){
    if(!form.justification.trim()){setMsg("Justification required");return;}
    try{
      var n=await api.post("/exceptions",{vuln_id:vuln.id,justification:form.justification,compensating_controls:form.compensating_controls});
      setExc(function(p){return [n].concat(p);});
      setShowForm(false);setForm({justification:"",compensating_controls:""});
      setMsg("Exception request submitted");
    }catch(e){setMsg(e.message);}
    setTimeout(function(){setMsg("");},4000);
  };

  var submitReview=async function(id){
    if(!review.review_note.trim()){setMsg("Review note required");return;}
    try{
      var n=await api.patch("/exceptions/"+id,review);
      setExc(function(p){return p.map(function(x){return x.id===id?Object.assign({},x,n):x;});});
      setReviewing(null);setMsg("Decision saved");
    }catch(e){setMsg(e.message);}
    setTimeout(function(){setMsg("");},4000);
  };

  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
    msg&&React.createElement("div",{style:{background:"#A100FF18",border:"1px solid #A100FF44",padding:"8px 12px",fontSize:12,color:"#A100FF"}},msg),

    // Current status banner
    exc.length>0&&React.createElement("div",{style:{
      background:sc[exc[0].status]+"18",border:"1px solid "+sc[exc[0].status]+"44",
      padding:"10px 14px",display:"flex",alignItems:"center",justifyContent:"space-between"
    }},
      React.createElement("div",null,
        React.createElement("div",{style:{fontSize:11,fontWeight:700,color:sc[exc[0].status],letterSpacing:.5}},
          "EXCEPTION "+exc[0].status.toUpperCase()
        ),
        exc[0].expires_at&&React.createElement("div",{style:{fontSize:11,color:T.text3,marginTop:2}},
          "Expires: "+new Date(exc[0].expires_at).toLocaleDateString()
        )
      ),
      exc[0].status==="Pending"&&canReview&&React.createElement("button",{
        onClick:function(){setReviewing(exc[0].id);setReview({status:"Approved",review_note:""}); },
        style:{background:"#A100FF",color:"#fff",border:"none",padding:"6px 14px",cursor:"pointer",fontSize:11,fontWeight:700}},
        "Review >"
      )
    ),

    // Exception history
    exc.length===0&&React.createElement("div",{style:{color:T.text3,fontSize:12,textAlign:"center",padding:"20px"}},
      "No exceptions for this vulnerability"
    ),

    exc.map(function(e){
      return React.createElement("div",{key:e.id,style:{background:T.inset,border:"1px solid "+T.border,padding:"12px 14px"}},
        React.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginBottom:8}},
          React.createElement("div",{style:{fontSize:11,color:T.text3}},
            "Submitted by ",React.createElement("strong",{style:{color:T.text}},e.submitter_name||"—"),
            " on "+new Date(e.created_at).toLocaleDateString()
          ),
          React.createElement("span",{style:{background:sc[e.status]+"22",color:sc[e.status],border:"1px solid "+sc[e.status]+"44",padding:"2px 8px",fontSize:10,fontWeight:700}},e.status)
        ),
        React.createElement("div",{style:{marginBottom:6}},
          React.createElement("div",{style:{fontSize:10,color:"#A100FF",fontWeight:700,letterSpacing:.5,marginBottom:3}},"JUSTIFICATION"),
          React.createElement("div",{style:{fontSize:12,color:T.text,lineHeight:1.6}},e.justification)
        ),
        e.compensating_controls&&React.createElement("div",{style:{marginBottom:6}},
          React.createElement("div",{style:{fontSize:10,color:"#A100FF",fontWeight:700,letterSpacing:.5,marginBottom:3}},"COMPENSATING CONTROLS"),
          React.createElement("div",{style:{fontSize:12,color:T.text,lineHeight:1.6}},e.compensating_controls)
        ),
        e.review_note&&React.createElement("div",{style:{background:sc[e.status]+"11",border:"1px solid "+sc[e.status]+"33",padding:"8px 10px",marginTop:8}},
          React.createElement("div",{style:{fontSize:10,color:sc[e.status],fontWeight:700,letterSpacing:.5,marginBottom:3}},
            "REVIEWER NOTE — "+e.reviewed_at?new Date(e.reviewed_at).toLocaleDateString():""
          ),
          React.createElement("div",{style:{fontSize:12,color:T.text}},e.review_note)
        )
      );
    }),

    // Review modal
    reviewing&&React.createElement("div",{style:{background:T.card,border:"1px solid #A100FF44",padding:"14px",marginTop:4}},
      React.createElement("div",{style:{fontSize:12,fontWeight:700,color:T.text,marginBottom:10}},"Review Exception"),
      React.createElement("div",{style:{display:"flex",gap:8,marginBottom:10}},
        ["Approved","Rejected"].map(function(s){
          return React.createElement("button",{key:s,onClick:function(){setReview(function(p){return Object.assign({},p,{status:s});});},
            style:{flex:1,padding:"8px",border:"1px solid "+(sc[s]||T.border),background:review.status===s?sc[s]+"22":"transparent",color:review.status===s?sc[s]:T.text3,cursor:"pointer",fontSize:12,fontWeight:review.status===s?700:400}},s);
        })
      ),
      React.createElement("textarea",{value:review.review_note,rows:3,placeholder:"Review note required...",
        onChange:function(e){setReview(function(p){return Object.assign({},p,{review_note:e.target.value});});},
        style:Object.assign({},iStyle,{resize:"vertical",marginBottom:8})
      }),
      React.createElement("div",{style:{display:"flex",gap:6,justifyContent:"flex-end"}},
        React.createElement("button",{onClick:function(){setReviewing(null);},style:{background:"transparent",border:"1px solid "+T.border,color:T.text3,padding:"7px 14px",cursor:"pointer",fontSize:11}},"Cancel"),
        React.createElement("button",{onClick:function(){submitReview(reviewing);},
          style:{background:review.status==="Approved"?"#22c55e":"#ef4444",color:"#fff",border:"none",padding:"7px 16px",cursor:"pointer",fontSize:11,fontWeight:700}},
          "Submit "+review.status)
      )
    ),

    // Submit new exception
    !showForm&&exc.filter(function(e){return e.status==="Pending"||e.status==="Approved";}).length===0&&
    React.createElement("button",{onClick:function(){setShowForm(true);},
      style:{alignSelf:"flex-start",background:"transparent",border:"1px solid #A100FF",color:"#A100FF",padding:"7px 16px",cursor:"pointer",fontSize:12,fontWeight:600}},
      "+ Request Exception"
    ),

    showForm&&React.createElement("div",{style:{background:T.inset,border:"1px solid "+T.border,padding:"12px 14px"}},
      React.createElement("div",{style:{fontSize:12,fontWeight:600,color:T.text,marginBottom:10}},"Request Exception"),
      React.createElement("div",{style:{marginBottom:8}},
        React.createElement("div",{style:{fontSize:10,color:T.text3,marginBottom:3,textTransform:"uppercase",letterSpacing:.5}},"Justification *"),
        React.createElement("textarea",{value:form.justification,rows:3,
          onChange:function(e){setForm(function(p){return Object.assign({},p,{justification:e.target.value});});},
          placeholder:"Business justification for deferring remediation...",
          style:Object.assign({},iStyle,{resize:"vertical"})})
      ),
      React.createElement("div",{style:{marginBottom:10}},
        React.createElement("div",{style:{fontSize:10,color:T.text3,marginBottom:3,textTransform:"uppercase",letterSpacing:.5}},"Compensating Controls"),
        React.createElement("textarea",{value:form.compensating_controls,rows:2,
          onChange:function(e){setForm(function(p){return Object.assign({},p,{compensating_controls:e.target.value});});},
          placeholder:"Controls in place to reduce risk while deferred...",
          style:Object.assign({},iStyle,{resize:"vertical"})})
      ),
      React.createElement("div",{style:{display:"flex",gap:6,justifyContent:"flex-end"}},
        React.createElement("button",{onClick:function(){setShowForm(false);},style:{background:"transparent",border:"1px solid "+T.border,color:T.text3,padding:"7px 14px",cursor:"pointer",fontSize:11}},"Cancel"),
        React.createElement("button",{onClick:submit,style:{background:"#A100FF",color:"#fff",border:"none",padding:"7px 16px",cursor:"pointer",fontSize:11,fontWeight:700}},"Submit >")
      )
    )
  );
}


function VulnDetail({vuln,user,onBack,onUpdate}){
  var T=React.useContext(ThemeCtx).T;
  var PURPLE="#A100FF";
  var SEV_C={Critical:"#ef4444",High:"#f97316",Medium:"#f59e0b",Low:"#22c55e"};
  var STAT_C={Open:"#6366f1","In Progress":"#3b82f6",Remediated:"#22c55e",Exception:"#8b5cf6",Overdue:"#f59e0b","SLA Breach":"#ef4444"};
  var _tab=useState("impact"); var activeTab=_tab[0]; var setActiveTab=_tab[1];
  var _msgs=useState([]); var msgs=_msgs[0]; var setMsgs=_msgs[1];
  var _note=useState(""); var note=_note[0]; var setNote=_note[1];
  var _status=useState(vuln.status); var status=_status[0]; var setStatus=_status[1];
  var _msg=useState(""); var msg=_msg[0]; var setMsg=_msg[1];
  var _vdata=useState(vuln); var vdata=_vdata[0]; var setVdata=_vdata[1];
  var _confirmState=useState(null); var confirmState=_confirmState[0]; var setConfirmState=_confirmState[1];

  useEffect(function(){
    api.get("/chat/"+vuln.id).then(setMsgs).catch(function(){});
    // Reload full vuln data to get latest saved fields
    api.get("/vulns/"+vuln.id).then(function(d){
      if(d) setVdata(d);
    }).catch(function(){});
  },[vuln.id]);

  var addNote=async function(){
    if(!note.trim()) return;
    try{
      var m=await api.post("/chat/"+vuln.id,{content:note});
      setMsgs(function(p){return [...p,m];});
      setNote("");
    }catch(e){setMsg("Error: "+e.message);}
  };

  var updateStatus=function(s){
    var cfgs={
      Remediated:{msg:"Mark as Remediated?",sub:"Confirm the fix has been applied and verified.",color:"#22c55e",label:"Mark Remediated"},
      Exception:{msg:"Mark as Exception?",sub:"An exception record will be created for Lead review.",color:"#8b5cf6",label:"Mark Exception"},
      Open:{msg:"Reopen this vulnerability?",sub:"This will reset it to Open status.",color:PURPLE,label:"Reopen"},
      "In Progress":{msg:"Mark as In Progress?",sub:"Confirm remediation work has started.",color:"#3b82f6",label:"Start Remediation"},
      Overdue:{msg:"Mark as Overdue?",sub:"SLA deadline has passed.",color:"#f59e0b",label:"Mark Overdue"},
      "SLA Breach":{msg:"Mark as SLA Breach?",sub:"This will trigger escalation notifications.",color:"#ef4444",label:"Mark SLA Breach"},
    };
    var cfg=cfgs[s]||{msg:"Change status to "+s+"?",color:PURPLE,label:"Confirm"};
    setConfirmState({msg:cfg.msg,subMsg:cfg.sub,confirmLabel:cfg.label,confirmColor:cfg.color,
      onConfirm:async function(){
        setConfirmState(null);
        try{
          var body={status:s};
          if(s==="Remediated") body.remediated_at=new Date().toISOString();
          await api.patch("/vulns/"+vuln.id,body);
          setStatus(s);
          onUpdate(Object.assign({},vdata,body));
          if(s==="Exception"){
            try{await api.post("/exceptions",{vuln_id:vuln.id,justification:"Exception raised by "+user.name+". Please update justification.",compensating_controls:"To be completed."});}catch(ex){}
          }
          var logMsgs={Remediated:"Marked Remediated by "+user.name+". Fix applied and verified.",Exception:"Marked Exception by "+user.name+". Exception request created.","In Progress":"Marked In Progress by "+user.name+". Remediation started.",Open:"Reopened by "+user.name+".",Overdue:"Marked Overdue by "+user.name+".","SLA Breach":"SLA Breach flagged by "+user.name+"."};
          try{var nm=await api.post("/chat/"+vuln.id,{content:logMsgs[s]||("Status changed to "+s+" by "+user.name)});setMsgs(function(p){return [...p,nm];});}catch(ex){}
        }catch(e){setMsg("Error: "+e.message);}
      },
      onCancel:function(){setConfirmState(null);}
    });
  };

  var handleSave=function(field,val){
    setVdata(function(p){var n=Object.assign({},p); n[field]=val; return n;});
  };

  var sevColor=SEV_C[vuln.severity]||"#64748b";
  var statColor=STAT_C[status]||"#64748b";
  var tabs=[["impact","Impact"],["remediation","Remediation"],["reproduce","Reproduce"],["ticket","Ticket"]];

  return React.createElement("div",null,
    confirmState&&React.createElement(ConfirmDialog,confirmState),
    React.createElement("div",{style:{display:"flex",height:"100vh",background:T.bg,fontFamily:"system-ui,sans-serif",color:T.text,flexDirection:"column",overflow:"hidden"}},
      React.createElement("style",null,"*{box-sizing:border-box;margin:0;padding:0;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif} ::-webkit-scrollbar{width:4px} ::-webkit-scrollbar-thumb{background:"+T.border+";border-radius:4px}"),

      // Header
      React.createElement("div",{style:{background:T.sidebar,borderBottom:"1px solid "+T.border,padding:"0 16px",display:"flex",alignItems:"center",gap:12,height:52,flexShrink:0}},
        React.createElement("button",{onClick:onBack,style:{background:"transparent",border:"none",color:T.text3,cursor:"pointer",fontSize:20,lineHeight:1}},"←"),
        React.createElement("div",{style:{fontSize:14,fontWeight:600,color:T.text,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},vuln.id+" — "+vuln.title),
        React.createElement("span",{style:{background:sevColor+"22",color:sevColor,border:"1px solid "+sevColor+"44",padding:"2px 10px",fontSize:12,fontWeight:700,borderRadius:4}},vuln.severity),
        React.createElement("span",{style:{background:statColor+"22",color:statColor,border:"1px solid "+statColor+"44",padding:"2px 10px",fontSize:12,fontWeight:700,borderRadius:4}},status)
      ),

      React.createElement("div",{style:{flex:1,display:"flex",overflow:"hidden"}},

        // Left panel
        React.createElement("div",{style:{width:"50%",overflowY:"auto",padding:16,display:"flex",flexDirection:"column",gap:12,flexShrink:0}},

          // Meta card
          React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,padding:"14px 16px"}},
            React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:12}},
              [["CVE",vuln.cve],["ASSET",vuln.asset],["CVSS",vuln.cvss],["EPSS",vuln.epss],["OWNER",vuln.owner_name],["POD",vuln.pod_name],["DUE",vuln.due_at?new Date(vuln.due_at).toLocaleDateString():"—"],["DAYS LEFT",(vuln.days_left<0?Math.abs(vuln.days_left)+"d OVERDUE":vuln.days_left+"d left")]].map(function(item){
                return React.createElement("div",{key:item[0]},
                  React.createElement("div",{style:{fontSize:9,color:T.text3,textTransform:"uppercase",letterSpacing:.8,marginBottom:3}},item[0]),
                  React.createElement("div",{style:{fontSize:13,fontWeight:600,color:item[0]==="DAYS LEFT"&&vuln.days_left<0?"#ef4444":T.text}},String(item[1]||"—"))
                );
              })
            )
          ),

          // Description
          vuln.description&&React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,padding:"14px 16px"}},
            React.createElement("div",{style:{fontSize:11,color:T.text3,textTransform:"uppercase",letterSpacing:.8,marginBottom:6}},"DESCRIPTION"),
            React.createElement("div",{style:{fontSize:13,color:T.text,lineHeight:1.7}},vuln.description)
          ),

          // CVSS/EPSS gauges
          React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,padding:"14px 16px",display:"flex",gap:20,justifyContent:"center"}},
            React.createElement(CVSSGauge,{score:parseFloat(vuln.cvss)||0,label:"CVSS"}),
            React.createElement(CVSSGauge,{score:(parseFloat(vuln.epss)||0)*10,label:"EPSS x10",color:"#6366f1"})
          ),

          // Status buttons
          React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,padding:"14px 16px"}},
            React.createElement("div",{style:{fontSize:11,color:T.text3,textTransform:"uppercase",letterSpacing:.8,marginBottom:10}},"UPDATE STATUS"),
            React.createElement("div",{style:{display:"flex",gap:8,flexWrap:"wrap"}},
              ["Open","In Progress","Remediated","Exception","Overdue","SLA Breach"].map(function(s){
                return React.createElement("button",{key:s,onClick:function(){updateStatus(s);},
                  style:{padding:"6px 12px",borderRadius:6,border:"1px solid "+(STAT_C[s]||T.border),
                    background:status===s?(STAT_C[s]||T.accent)+"22":"transparent",
                    color:status===s?(STAT_C[s]||T.accent):T.text3,
                    fontSize:12,cursor:"pointer",fontWeight:status===s?600:400}},s);
              })
            )
          ),

          // Tabs
          React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,overflow:"hidden"}},
            React.createElement("div",{style:{display:"flex",borderBottom:"1px solid "+T.border}},
              tabs.map(function(t){
                return React.createElement("button",{key:t[0],onClick:function(){setActiveTab(t[0]);},
                  style:{flex:1,padding:"10px 6px",border:"none",borderBottom:activeTab===t[0]?"2px solid "+PURPLE:"2px solid transparent",
                    background:"transparent",color:activeTab===t[0]?PURPLE:T.text3,cursor:"pointer",fontSize:12,fontWeight:activeTab===t[0]?700:400}},t[1]);
              })
            ),
            React.createElement("div",{style:{padding:16}},
              activeTab==="impact"&&React.createElement("div",null,
                React.createElement(VulnDetailSection,{title:"BUSINESS IMPACT",content:vdata.impact,vuln:vdata,field:"impact",user:user,onSave:handleSave}),
                React.createElement(VulnDetailSection,{title:"AFFECTED VERSIONS",content:vdata.affected_versions,vuln:vdata,field:"affected_versions",user:user,onSave:handleSave}),
                vdata.patch_available&&React.createElement("div",{style:{background:"#22c55e11",border:"1px solid #22c55e44",borderRadius:8,padding:"10px 14px",fontSize:12,color:"#22c55e",fontWeight:600}},"Patch Available"+(vdata.patch_url?" — "+vdata.patch_url:""))
              ),
              activeTab==="remediation"&&React.createElement("div",null,
                React.createElement(VulnDetailSection,{title:"REMEDIATION STEPS",content:vdata.remediation,vuln:vdata,field:"remediation",user:user,onSave:handleSave}),
                React.createElement(VulnDetailSection,{title:"INTERNAL NOTES",content:vdata.internal_notes,vuln:vdata,field:"internal_notes",user:user,onSave:handleSave})
              ),
              activeTab==="reproduce"&&React.createElement("div",null,
                React.createElement(VulnDetailSection,{title:"STEPS TO REPRODUCE",content:vdata.steps_to_reproduce,vuln:vdata,field:"steps_to_reproduce",isCode:true,user:user,onSave:handleSave}),
                React.createElement(VulnDetailSection,{title:"WORKAROUND",content:vdata.workaround,vuln:vdata,field:"workaround",user:user,onSave:handleSave})
              ),
              activeTab==="ticket"&&React.createElement(TicketWidget,{vuln:vdata,user:user})
            )
          ),
          msg&&React.createElement("div",{style:{color:"#ef4444",fontSize:12}},msg)
        ),

        // Right panel - chat
        React.createElement("div",{style:{width:"50%",borderLeft:"1px solid "+T.border,display:"flex",flexDirection:"column",flexShrink:0}},
          React.createElement("div",{style:{padding:"12px 14px",borderBottom:"1px solid "+T.border,fontSize:13,fontWeight:600,color:T.text}},"Follow-up Log"),
          React.createElement("div",{style:{flex:1,overflowY:"auto",padding:"10px 14px",display:"flex",flexDirection:"column",gap:10}},
            msgs.map(function(m){
              return React.createElement("div",{key:m.id},
                React.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginBottom:3}},
                  React.createElement("span",{style:{fontSize:11,fontWeight:600,color:m.role==="agent"?PURPLE:T.accent}},m.author_name||m.role),
                  React.createElement("span",{style:{fontSize:10,color:T.text3}},m.created_at?new Date(m.created_at).toLocaleDateString():"")
                ),
                React.createElement("div",{style:{fontSize:12,color:T.text,lineHeight:1.6,background:T.inset,padding:"8px 10px",borderRadius:6}},m.content)
              );
            })
          ),
          // AI buttons
          React.createElement("div",{style:{padding:"8px 14px",borderTop:"1px solid "+T.border,display:"flex",gap:6,flexWrap:"wrap"}},
            [["Agent Reply",async function(){
              try{var d=await api.post("/agent/chat",{messages:[{role:"user",content:"Analyse "+vuln.id+": "+vuln.title+" ("+vuln.severity+", CVSS:"+vuln.cvss+"). Provide brief risk assessment and top 3 remediation steps. Be concise."}]});
              var m=await api.post("/chat/"+vuln.id,{content:d.reply});setMsgs(function(p){return [...p,m];});}catch(e){setMsg(e.message);}
            },"#6366f1"],
            ["SLA Reminder",async function(){
              try{var d=await api.post("/agent/chat",{messages:[{role:"user",content:"Draft a brief SLA reminder for "+vuln.id+" ("+vuln.severity+", "+Math.abs(vuln.days_left||0)+"d "+(vuln.days_left<0?"overdue":"remaining")+"). Keep it under 3 sentences."}]});
              var m=await api.post("/chat/"+vuln.id,{content:d.reply});setMsgs(function(p){return [...p,m];});}catch(e){setMsg(e.message);}
            },"#f59e0b"],
            ["R Fix Plan",async function(){
              try{var d=await api.post("/agent/chat",{messages:[{role:"user",content:"Create a 2-week remediation plan for "+vuln.id+": "+vuln.title+". Format as bullet points with specific days."}]});
              var m=await api.post("/chat/"+vuln.id,{content:d.reply});setMsgs(function(p){return [...p,m];});}catch(e){setMsg(e.message);}
            },"#22c55e"]].map(function(btn){
              return React.createElement("button",{key:btn[0],onClick:btn[1],style:{background:btn[2]+"22",color:btn[2],border:"1px solid "+btn[2]+"44",padding:"4px 10px",cursor:"pointer",fontSize:11,fontWeight:600,borderRadius:4}},btn[0]);
            })
          ),
          // Add note
          React.createElement("div",{style:{padding:"8px 14px",borderTop:"1px solid "+T.border,display:"flex",gap:6}},
            React.createElement("input",{value:note,onChange:function(e){setNote(e.target.value);},onKeyDown:function(e){if(e.key==="Enter")addNote();},
              placeholder:"Add a note...",
              style:{flex:1,padding:"6px 10px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:12,outline:"none",borderRadius:6}}),
            React.createElement("button",{onClick:addNote,style:{background:PURPLE,color:"#fff",border:"none",padding:"6px 14px",cursor:"pointer",fontSize:12,fontWeight:700,borderRadius:6}},"Add >")
          )
        )
      )
    )
  );
}


function BulkModal({onClose}){
  var T=React.useContext(ThemeCtx).T;
  var PURPLE="#A100FF";
  var _tab=useState("import"); var tab=_tab[0]; var setTab=_tab[1];
  var _rtype=useState("penetration_testing"); var rtype=_rtype[0]; var setRtype=_rtype[1];
  var _text=useState(""); var text=_text[0]; var setText=_text[1];
  var _fname=useState(""); var fname=_fname[0]; var setFname=_fname[1];
  var _findings=useState([]); var findings=_findings[0]; var setFindings=_findings[1];
  var _selected=useState([]); var selected=_selected[0]; var setSelected=_selected[1];
  var _sessionId=useState(null); var sessionId=_sessionId[0]; var setSessionId=_sessionId[1];
  var _loading=useState(false); var loading=_loading[0]; var setLoading=_loading[1];
  var _step=useState("upload"); var step=_step[0]; var setStep=_step[1];
  var _msg=useState(""); var msg=_msg[0]; var setMsg=_msg[1];
  var _format=useState(""); var format=_format[0]; var setFormat=_format[1];
  var _sessions=useState([]); var sessions=_sessions[0]; var setSessions=_sessions[1];

  var REPORT_TYPES=[
    {id:"penetration_testing",label:"Penetration Testing"},
    {id:"application_security",label:"Application Security"},
    {id:"infrastructure",label:"Infrastructure Scan"},
    {id:"sast",label:"SAST"},
    {id:"dast",label:"DAST"},
    {id:"sca",label:"SCA / Dependency Scan"},
    {id:"container",label:"Container Scan"},
    {id:"threat_modeling",label:"Threat Modeling"},
  ];

  var iStyle={width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,
    color:T.text,fontSize:12,outline:"none",boxSizing:"border-box"};

  useEffect(function(){
    if(tab==="history"){
      api.get("/aiimport/sessions").then(setSessions).catch(function(){});
    }
  },[tab]);

  var onFile=function(e){
    var file=e.target.files[0]; if(!file) return;
    setFname(file.name);
    var reader=new FileReader();
    reader.onload=function(ev){ setText(ev.target.result); };
    reader.readAsText(file);
  };

  var analyse=async function(){
    if(!text.trim()){setMsg("Please paste text or upload a file");return;}
    setLoading(true); setMsg(""); setStep("analysing");
    try{
      var d=await api.post("/aiimport/analyse",{text,filename:fname,report_type:rtype});
      setFindings(d.findings||[]); setSessionId(d.session_id);
      setSelected(d.findings.map(function(_,i){return i;}));
      setFormat(d.format||"");
      setStep("preview");
      setMsg("Detected format: "+d.format+" · "+d.count+" findings extracted");
    }catch(e){setMsg("Error: "+e.message);setStep("upload");}
    setLoading(false);
  };

  var confirmImport=async function(){
    setLoading(true); setMsg("");
    try{
      var d=await api.post("/aiimport/confirm/"+sessionId,{selected});
      setMsg("Imported "+d.imported+" of "+d.total+" vulnerabilities");
      setStep("done");
    }catch(e){setMsg("Error: "+e.message);}
    setLoading(false);
  };

  var toggleAll=function(){
    if(selected.length===findings.length) setSelected([]);
    else setSelected(findings.map(function(_,i){return i;}));
  };

  var SEV_C={Critical:"#ef4444",High:"#f97316",Medium:"#f59e0b",Low:"#22c55e"};

  return React.createElement(Modal,{title:"Import Vulnerabilities",onClose:onClose,width:900},
    React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},

      // Tabs
      React.createElement("div",{style:{display:"flex",borderBottom:"1px solid "+T.border,gap:2}},
        [["import","Import Report"],["history","Import History"]].map(function(t){
          return React.createElement("button",{key:t[0],onClick:function(){setTab(t[0]);setStep("upload");},
            style:{padding:"8px 16px",background:"transparent",border:"none",
              borderBottom:tab===t[0]?"2px solid "+PURPLE:"2px solid transparent",
              color:tab===t[0]?PURPLE:T.text3,cursor:"pointer",fontSize:12,fontWeight:tab===t[0]?700:400}},t[1]);
        })
      ),

      // Import tab
      tab==="import"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},

        // Step: Upload
        step==="upload"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
          // Report type
          React.createElement("div",null,
            React.createElement("div",{style:{fontSize:11,color:T.text3,marginBottom:4,textTransform:"uppercase",letterSpacing:.5}},"Report Type"),
            React.createElement("select",{value:rtype,onChange:function(e){setRtype(e.target.value);},style:iStyle},
              REPORT_TYPES.map(function(r){return React.createElement("option",{key:r.id,value:r.id},r.label);})
            )
          ),

          // Supported formats info
          React.createElement("div",{style:{background:T.inset,padding:"10px 12px",fontSize:11,color:T.text2,lineHeight:1.8}},
            React.createElement("div",{style:{fontWeight:700,color:T.text,marginBottom:4}},"Supported formats:"),
            React.createElement("div",null,
              React.createElement("span",{style:{color:"#22c55e",fontWeight:600}},"Auto-detected: "),
              "Nessus CSV · Snyk JSON · Trivy JSON · OWASP ZAP JSON · Checkmarx JSON · Generic CSV"
            ),
            React.createElement("div",{style:{marginTop:4}},
              React.createElement("span",{style:{color:PURPLE,fontWeight:600}},"AI-assisted: "),
              "PDF reports · Word docs · Custom formats · Paste raw text"
            )
          ),

          // File upload
          React.createElement("div",null,
            React.createElement("div",{style:{fontSize:11,color:T.text3,marginBottom:4,textTransform:"uppercase",letterSpacing:.5}},"Upload File"),
            React.createElement("input",{type:"file",accept:".csv,.json,.xml,.txt,.pdf,.docx",
              onChange:onFile,
              style:{width:"100%",padding:"8px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:12,cursor:"pointer"}})
          ),

          // Or paste text
          React.createElement("div",null,
            React.createElement("div",{style:{fontSize:11,color:T.text3,marginBottom:4,textTransform:"uppercase",letterSpacing:.5}},"Or Paste Report Text"),
            React.createElement("textarea",{value:text,rows:8,
              placeholder:"Paste Nessus CSV, Snyk JSON, Trivy output, or any report text here...",
              onChange:function(e){setText(e.target.value);},
              style:Object.assign({},iStyle,{resize:"vertical",fontFamily:"monospace",fontSize:11})})
          ),

          msg&&React.createElement("div",{style:{fontSize:12,color:msg.startsWith("Error")?"#ef4444":"#A100FF",padding:"6px 10px",background:msg.startsWith("Error")?"#ef444411":"#A100FF11"}},msg),

          React.createElement("button",{onClick:analyse,disabled:loading||!text.trim(),
            style:{background:PURPLE,color:"#fff",border:"none",padding:"11px",
              cursor:"pointer",fontSize:13,fontWeight:700,opacity:loading||!text.trim()?0.5:1}},
            loading?"Analysing...":"Analyse & Extract Findings >")
        ),

        // Step: Analysing
        step==="analysing"&&React.createElement("div",{style:{textAlign:"center",padding:"40px 20px"}},
          React.createElement("div",{style:{fontSize:32,marginBottom:12}}),
          React.createElement("div",{style:{fontSize:14,color:T.text,fontWeight:600}},"Analysing report..."),
          React.createElement("div",{style:{fontSize:12,color:T.text3,marginTop:8}},"Extracting vulnerability findings")
        ),

        // Step: Preview
        step==="preview"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
          React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center"}},
            React.createElement("div",null,
              React.createElement("div",{style:{fontSize:13,color:T.text,fontWeight:700}},findings.length+" findings extracted"),
              React.createElement("div",{style:{fontSize:11,color:T.text3}},msg)
            ),
            React.createElement("div",{style:{display:"flex",gap:8}},
              React.createElement("button",{onClick:toggleAll,style:{background:T.inset,color:T.text2,border:"1px solid "+T.border,padding:"5px 12px",cursor:"pointer",fontSize:11}},
                selected.length===findings.length?"Deselect All":"Select All ("+findings.length+")"),
              React.createElement("button",{onClick:function(){setStep("upload");setFindings([]);},
                style:{background:"transparent",color:T.text3,border:"1px solid "+T.border,padding:"5px 12px",cursor:"pointer",fontSize:11}},"Back")
            )
          ),

          // Preview table
          React.createElement("div",{style:{maxHeight:320,overflowY:"auto",border:"1px solid "+T.border}},
            React.createElement("table",{style:{width:"100%",borderCollapse:"collapse",fontSize:11}},
              React.createElement("thead",null,
                React.createElement("tr",{style:{background:T.inset,position:"sticky",top:0}},
                  ["","#","Title","Severity","Asset","CVE","Scanner"].map(function(h){
                    return React.createElement("th",{key:h,style:{padding:"6px 8px",textAlign:"left",color:T.text3,fontWeight:600,fontSize:10,textTransform:"uppercase"}},h);
                  })
                )
              ),
              React.createElement("tbody",null,
                findings.map(function(f,i){
                  var isSelected=selected.includes(i);
                  return React.createElement("tr",{key:i,
                    style:{background:isSelected?T.accentBg:T.card,borderBottom:"1px solid "+T.border,cursor:"pointer"},
                    onClick:function(){setSelected(function(p){return p.includes(i)?p.filter(function(x){return x!==i;}):[...p,i];});}},
                    React.createElement("td",{style:{padding:"6px 8px"}},
                      React.createElement("input",{type:"checkbox",checked:isSelected,readOnly:true})
                    ),
                    React.createElement("td",{style:{padding:"6px 8px",color:T.text3}},i+1),
                    React.createElement("td",{style:{padding:"6px 8px",color:T.text,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},f.title),
                    React.createElement("td",{style:{padding:"6px 8px"}},
                      React.createElement("span",{style:{color:SEV_C[f.severity]||T.text3,fontWeight:700}},f.severity)
                    ),
                    React.createElement("td",{style:{padding:"6px 8px",color:T.text2,maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},f.asset),
                    React.createElement("td",{style:{padding:"6px 8px",color:T.text3}},f.cve),
                    React.createElement("td",{style:{padding:"6px 8px",color:T.text3}},f.scanner_name||f.scan_type||"-")
                  );
                })
              )
            )
          ),

          React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center"}},
            React.createElement("div",{style:{fontSize:12,color:T.text3}},selected.length+" of "+findings.length+" selected"),
            React.createElement("button",{onClick:confirmImport,disabled:loading||selected.length===0,
              style:{background:"#22c55e",color:"#fff",border:"none",padding:"10px 24px",
                cursor:"pointer",fontSize:13,fontWeight:700,opacity:loading||selected.length===0?0.5:1}},
              loading?"Importing...":"Import "+selected.length+" Findings >")
          )
        ),

        // Step: Done
        step==="done"&&React.createElement("div",{style:{textAlign:"center",padding:"32px 20px"}},
          React.createElement("div",{style:{fontSize:40,marginBottom:12}}),
          React.createElement("div",{style:{fontSize:16,color:"#22c55e",fontWeight:700,marginBottom:8}},msg),
          React.createElement("div",{style:{fontSize:12,color:T.text3,marginBottom:20}},"Vulnerabilities are now visible in the Vulnerabilities page"),
          React.createElement("button",{onClick:function(){setStep("upload");setFindings([]);setText("");setFname("");setMsg("");},
            style:{background:PURPLE,color:"#fff",border:"none",padding:"10px 24px",cursor:"pointer",fontSize:13,fontWeight:700}},
            "Import More")
        )
      ),

      // History tab
      tab==="history"&&React.createElement("div",null,
        sessions.length===0
          ? React.createElement("div",{style:{textAlign:"center",padding:"32px",color:T.text3,fontSize:13}},"No import sessions yet")
          : React.createElement("table",{style:{width:"100%",borderCollapse:"collapse",fontSize:12}},
              React.createElement("thead",null,
                React.createElement("tr",{style:{background:T.inset}},
                  ["File","Type","Imported","Status","Date","By"].map(function(h){
                    return React.createElement("th",{key:h,style:{padding:"8px",textAlign:"left",color:T.text3,fontSize:10,textTransform:"uppercase"}},h);
                  })
                )
              ),
              React.createElement("tbody",null,
                sessions.map(function(s){
                  return React.createElement("tr",{key:s.id,style:{borderBottom:"1px solid "+T.border}},
                    React.createElement("td",{style:{padding:"8px",color:T.text}},s.filename||"Pasted text"),
                    React.createElement("td",{style:{padding:"8px",color:T.text2}},s.report_type||"-"),
                    React.createElement("td",{style:{padding:"8px",color:"#22c55e",fontWeight:700}},s.imported||0),
                    React.createElement("td",{style:{padding:"8px"}},
                      React.createElement("span",{style:{background:s.status==="imported"?"#22c55e22":"#f59e0b22",
                        color:s.status==="imported"?"#22c55e":"#f59e0b",padding:"2px 8px",fontSize:10,fontWeight:700}},s.status)
                    ),
                    React.createElement("td",{style:{padding:"8px",color:T.text3}},new Date(s.created_at).toLocaleDateString()),
                    React.createElement("td",{style:{padding:"8px",color:T.text2}},s.user_name||"-")
                  );
                })
              )
            )
      )
    )
  );
}


function ExportModal({onClose, user, myVulns}){
  var T=React.useContext(ThemeCtx).T;
  var _loading=useState(false); var loading=_loading[0]; var setLoading=_loading[1];
  var _msg=useState(""); var msg=_msg[0]; var setMsg=_msg[1];
  var PURPLE="#A100FF";
  var doExport=async function(type){
    setLoading(true); setMsg("");
    try{
      var res=await api.request("/exports/"+type,{_raw:true});
      if(!res.ok) throw new Error("Export failed: "+res.status);
      var blob=await res.blob();
      var url=URL.createObjectURL(blob);
      var a=document.createElement("a");
      a.href=url; a.download="avta-report."+(type==="excel"?"xlsx":type==="ppt"?"pptx":type==="html"?"html":type); a.click();
      setTimeout(function(){URL.revokeObjectURL(url);},1000);
      setMsg("Export downloaded");
    }catch(e){setMsg("Error: "+e.message);}
    setLoading(false);
    setTimeout(function(){setMsg("");},3000);
  };
  return React.createElement(Modal,{title:"Export Report",onClose:onClose},
    React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
      msg&&React.createElement("div",{style:{fontSize:12,color:msg.startsWith("Error")?"#ef4444":"#22c55e",padding:"6px 10px",background:msg.startsWith("Error")?"#ef444411":"#22c55e11"}},msg),
      React.createElement("div",{style:{fontSize:13,color:T.text,marginBottom:4}},"Export ",React.createElement("strong",null,myVulns.length)," vulnerabilities"),
      React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:8}},
        React.createElement("button",{onClick:function(){doExport("excel");},disabled:loading,style:{background:"#22c55e",color:"#fff",border:"none",padding:"12px",cursor:"pointer",fontSize:13,fontWeight:700,opacity:loading?0.6:1,textAlign:"left"}},"Excel (.xlsx)  —  Summary, Vulnerabilities, SLA Alerts, Follow-up Log, Exceptions"),

        React.createElement("button",{onClick:function(){
          // Open directly — avoids blob URL which blocks local script loading
          var url="/api/exports/html";
          var tok=api._getToken?api._getToken():null;
          if(tok) url+="?token="+encodeURIComponent(tok);
          window.open(url,"_blank");
        },disabled:loading,style:{background:"#0891b2",color:"#fff",border:"none",padding:"12px",cursor:"pointer",fontSize:13,fontWeight:700,opacity:loading?0.6:1,textAlign:"left"}},
        "Interactive HTML Report  —  Executive dashboard with charts, filters, sortable table, CSV export")
      ),
      loading&&React.createElement("div",{style:{fontSize:12,color:T.text3,textAlign:"center"}},"Generating export...")
    )
  );
}


function NewVulnModal({onClose, onAdd, vulns}){
  var T=React.useContext(ThemeCtx).T;
  var _form=useState({cve:"",title:"",asset:"",severity:"High",description:"",cvss:"",epss:"",scan_type:"manual",scanner_name:""});
  var form=_form[0]; var setForm=_form[1];
  var _err=useState(""); var err=_err[0]; var setErr=_err[1];
  var _loading=useState(false); var loading=_loading[0]; var setLoading=_loading[1];
  var PURPLE="#A100FF";
  var iStyle={width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:12,outline:"none",boxSizing:"border-box"};
  var lStyle={fontSize:10,color:T.text3,marginBottom:3,textTransform:"uppercase",letterSpacing:.5,display:"block"};
  var setF=function(k,v){setForm(function(p){return Object.assign({},p,{[k]:v});});};
  var submit=async function(){
    if(!form.cve.trim()||!form.title.trim()||!form.asset.trim()||!form.severity){setErr("CVE, Title, Asset and Severity are required");return;}
    setLoading(true); setErr("");
    try{await onAdd(form);onClose();}
    catch(e){setErr(e.message||"Failed to create vulnerability");}
    setLoading(false);
  };
  return React.createElement(Modal,{title:"New Vulnerability",onClose:onClose,width:560},
    React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
      err&&React.createElement("div",{style:{background:"#ef444411",border:"1px solid #ef444433",padding:"8px 10px",fontSize:12,color:"#ef4444"}},err),
      React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}},
        React.createElement("div",null,React.createElement("label",{style:lStyle},"CVE ID *"),React.createElement("input",{type:"text",value:form.cve,placeholder:"CVE-2024-XXXXX",onChange:function(e){setF("cve",e.target.value);},style:iStyle})),
        React.createElement("div",null,React.createElement("label",{style:lStyle},"Severity *"),React.createElement("select",{value:form.severity,onChange:function(e){setF("severity",e.target.value);},style:iStyle},["Critical","High","Medium","Low"].map(function(s){return React.createElement("option",{key:s,value:s},s);})))
      ),
      React.createElement("div",null,React.createElement("label",{style:lStyle},"Title *"),React.createElement("input",{type:"text",value:form.title,placeholder:"Short vulnerability description",onChange:function(e){setF("title",e.target.value);},style:iStyle})),
      React.createElement("div",null,React.createElement("label",{style:lStyle},"Asset *"),React.createElement("input",{type:"text",value:form.asset,placeholder:"Asset name or IP",onChange:function(e){setF("asset",e.target.value);},style:iStyle})),
      React.createElement("div",null,React.createElement("label",{style:lStyle},"Description"),React.createElement("textarea",{value:form.description,rows:3,placeholder:"Vulnerability details...",onChange:function(e){setF("description",e.target.value);},style:Object.assign({},iStyle,{resize:"vertical"})})),
      React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}},
        React.createElement("div",null,React.createElement("label",{style:lStyle},"CVSS"),React.createElement("input",{type:"number",min:"0",max:"10",step:"0.1",value:form.cvss,placeholder:"0.0",onChange:function(e){setF("cvss",e.target.value);},style:iStyle})),
        React.createElement("div",null,React.createElement("label",{style:lStyle},"EPSS"),React.createElement("input",{type:"number",min:"0",max:"1",step:"0.01",value:form.epss,placeholder:"0.00",onChange:function(e){setF("epss",e.target.value);},style:iStyle})),
        React.createElement("div",null,React.createElement("label",{style:lStyle},"Scan Type"),React.createElement("select",{value:form.scan_type,onChange:function(e){setF("scan_type",e.target.value);},style:iStyle},["manual","sast","dast","infra","sca","container","api"].map(function(s){return React.createElement("option",{key:s,value:s},s);})))
      ),
      React.createElement("button",{onClick:submit,disabled:loading,style:{background:PURPLE,color:"#fff",border:"none",padding:"11px",cursor:"pointer",fontSize:13,fontWeight:700,opacity:loading?0.6:1}},loading?"Creating...":"Create Vulnerability >")
    )
  );
}


